module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/rc-switch/es/index.js
// module id = 2604
// module chunks = 0